import { useEffect, useState } from 'react';
import { CountriesApi } from '../../../api';
import { CountryDto } from '../../../commonTypes/country.types';
import { useContainer } from '../../useContainer';

const useHttpGetCountriesOnMount = () => {
    const countriesApi: CountriesApi = useContainer(CountriesApi);
    const [data, setData] = useState<CountryDto[]>([]);
    const [areCountriesReady, setAreCountriesReady] = useState<boolean>();

    const { exec, abort } = countriesApi.getAll({
        onSuccess: res => setData(res.body),
        onFinally: () => setAreCountriesReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { data, areCountriesReady };
};

export default useHttpGetCountriesOnMount;
